import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { AppRoute } from '@/common/app/routes';
import { MainButton } from '@/components/ui/Button/Button';
import { useAppSelector } from '@/redux/store';

import { DiceCount } from '../DiceCount/DiceCount';

import { PhaseInfo } from './PhaseInfo/PhaseInfo';
import { TimeToEndPhase } from './TimeToEndPhase/TimeToEndPhase';

const AccumulationPhase: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const diceQuantity = useAppSelector((state) => state.diceGame.dice);

  const toMainPage = (): void => {
    navigate(AppRoute.MAIN);
  };

  return (
    <div className="flex flex-col items-center w-full px-6">
      <TimeToEndPhase />
      <PhaseInfo />
      <DiceCount
        className="mb-8"
        quantity={diceQuantity || 0}
        withAddButton={true}
      />
      <MainButton
        onClick={toMainPage}
        text={t("Got it! I'll be back later")}
        className="mb-6"
      />
    </div>
  );
};

export { AccumulationPhase };
